/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscriptionSuccessRouteImport } from './routes/subscription-success'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as OnboardingCallRouteImport } from './routes/onboarding-call'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KickstarterCallRouteImport } from './routes/kickstarter-call'
import { Route as KickstarterRouteImport } from './routes/kickstarter'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CreatePasswordRouteImport } from './routes/create-password'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthAppShellRouteImport } from './routes/_auth/_app-shell'
import { Route as AuthAppShellMakeASuggestionRouteImport } from './routes/_auth/_app-shell/make-a-suggestion'
import { Route as AuthAppShellWhitelabelIndexRouteImport } from './routes/_auth/_app-shell/whitelabel/index'
import { Route as AuthAppShellUsersIndexRouteImport } from './routes/_auth/_app-shell/users/index'
import { Route as AuthAppShellTrashIndexRouteImport } from './routes/_auth/_app-shell/trash/index'
import { Route as AuthAppShellTeamsIndexRouteImport } from './routes/_auth/_app-shell/teams/index'
import { Route as AuthAppShellRequestsIndexRouteImport } from './routes/_auth/_app-shell/requests/index'
import { Route as AuthAppShellPublishIndexRouteImport } from './routes/_auth/_app-shell/publish/index'
import { Route as AuthAppShellProjectsIndexRouteImport } from './routes/_auth/_app-shell/projects/index'
import { Route as AuthAppShellNotificationsIndexRouteImport } from './routes/_auth/_app-shell/notifications/index'
import { Route as AuthAppShellMyFilesIndexRouteImport } from './routes/_auth/_app-shell/my-files/index'
import { Route as AuthAppShellIssuesReportsIndexRouteImport } from './routes/_auth/_app-shell/issues-reports/index'
import { Route as AuthAppShellDashboardIndexRouteImport } from './routes/_auth/_app-shell/dashboard/index'
import { Route as AuthAppShellBrandsIndexRouteImport } from './routes/_auth/_app-shell/brands/index'
import { Route as AuthAppShellBillingIndexRouteImport } from './routes/_auth/_app-shell/billing/index'
import { Route as AuthAppShellWhitelabelDashboardRouteImport } from './routes/_auth/_app-shell/whitelabel/dashboard'
import { Route as AuthAppShellWhitelabelCreateRouteImport } from './routes/_auth/_app-shell/whitelabel/create'
import { Route as AuthAppShellUsersCreateRouteImport } from './routes/_auth/_app-shell/users/create'
import { Route as AuthAppShellUserProfileRouteImport } from './routes/_auth/_app-shell/user/profile'
import { Route as AuthAppShellTeamsCreateRouteImport } from './routes/_auth/_app-shell/teams/create'
import { Route as AuthAppShellRequestsTemplateRouteImport } from './routes/_auth/_app-shell/requests/template'
import { Route as AuthAppShellRequestsPickTypeRouteImport } from './routes/_auth/_app-shell/requests/pick-type'
import { Route as AuthAppShellRequestsMbcReviewRouteImport } from './routes/_auth/_app-shell/requests/mbc-review'
import { Route as AuthAppShellRequestsMbcRouteImport } from './routes/_auth/_app-shell/requests/mbc'
import { Route as AuthAppShellRequestsCreateRouteImport } from './routes/_auth/_app-shell/requests/create'
import { Route as AuthAppShellProjectsProjectIdRouteImport } from './routes/_auth/_app-shell/projects/$projectId'
import { Route as AuthAppShellProjectAssociatedRequestsProjectIdRouteImport } from './routes/_auth/_app-shell/project-associated-requests/$projectId'
import { Route as AuthAppShellProfileDesignerPreferenceRouteImport } from './routes/_auth/_app-shell/profile/designer-preference'
import { Route as AuthAppShellPaywallNoCreditsRouteImport } from './routes/_auth/_app-shell/paywall/no-credits'
import { Route as AuthAppShellPaywallExpiredSubscriptionRouteImport } from './routes/_auth/_app-shell/paywall/expired-subscription'
import { Route as AuthAppShellNotificationsSettingsRouteImport } from './routes/_auth/_app-shell/notifications/settings'
import { Route as AuthAppShellMyFilesTemplateRouteImport } from './routes/_auth/_app-shell/my-files/template'
import { Route as AuthAppShellBrandsCreateRouteImport } from './routes/_auth/_app-shell/brands/create'
import { Route as AuthAppShellBrandsBrandIdRouteImport } from './routes/_auth/_app-shell/brands/$brandId'
import { Route as AuthAppShellBillingProjectIdRouteImport } from './routes/_auth/_app-shell/billing/$projectId'
import { Route as AuthAppShellAdminConfidenceCheckerRouteImport } from './routes/_auth/_app-shell/admin/confidence-checker'
import { Route as AuthAppShellProjectsProjectIdIndexRouteImport } from './routes/_auth/_app-shell/projects/$projectId/index'
import { Route as AuthAppShellBrandsBrandIdIndexRouteImport } from './routes/_auth/_app-shell/brands/$brandId/index'
import { Route as AuthAppShellBillingProjectIdIndexRouteImport } from './routes/_auth/_app-shell/billing/$projectId/index'
import { Route as AuthAppShellAdminSubcategoriesIndexRouteImport } from './routes/_auth/_app-shell/admin/subcategories/index'
import { Route as AuthAppShellAdminMbcIndexRouteImport } from './routes/_auth/_app-shell/admin/mbc/index'
import { Route as AuthAppShellAdminDesignTypesIndexRouteImport } from './routes/_auth/_app-shell/admin/design-types/index'
import { Route as AuthAppShellWhitelabelConfigIdEditRouteImport } from './routes/_auth/_app-shell/whitelabel/$configId.edit'
import { Route as AuthAppShellUsersUserIdEditRouteImport } from './routes/_auth/_app-shell/users/$userId.edit'
import { Route as AuthAppShellTeamsIdEditRouteImport } from './routes/_auth/_app-shell/teams/$id.edit'
import { Route as AuthAppShellRequestsRequestIdEditRouteImport } from './routes/_auth/_app-shell/requests/$requestId/edit'
import { Route as AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRouteImport } from './routes/_auth/_app-shell/requests/$requestId/confidence-checker-summary'
import { Route as AuthAppShellPublishPostsPostIdRouteImport } from './routes/_auth/_app-shell/publish/posts/$postId'
import { Route as AuthAppShellProjectsProjectIdUsersRouteImport } from './routes/_auth/_app-shell/projects/$projectId/users'
import { Route as AuthAppShellProjectsProjectIdInternalNotesRouteImport } from './routes/_auth/_app-shell/projects/$projectId/internal-notes'
import { Route as AuthAppShellProjectsProjectIdEditRouteImport } from './routes/_auth/_app-shell/projects/$projectId/edit'
import { Route as AuthAppShellProjectsProjectIdBrandsRouteImport } from './routes/_auth/_app-shell/projects/$projectId/brands'
import { Route as AuthAppShellBrandsBrandIdVisualdirectionRouteImport } from './routes/_auth/_app-shell/brands/$brandId/visualdirection'
import { Route as AuthAppShellBrandsBrandIdRequestsRouteImport } from './routes/_auth/_app-shell/brands/$brandId/requests'
import { Route as AuthAppShellBrandsBrandIdOverviewRouteImport } from './routes/_auth/_app-shell/brands/$brandId/overview'
import { Route as AuthAppShellBrandsBrandIdKnowledgeRouteImport } from './routes/_auth/_app-shell/brands/$brandId/knowledge'
import { Route as AuthAppShellBrandsBrandIdEditRouteImport } from './routes/_auth/_app-shell/brands/$brandId.edit'
import { Route as AuthAppShellBrandsBrandIdSplatRouteImport } from './routes/_auth/_app-shell/brands/$brandId/$'
import { Route as AuthAppShellBillingProjectIdPaymentMethodsRouteImport } from './routes/_auth/_app-shell/billing/$projectId/payment-methods'
import { Route as AuthAppShellBillingProjectIdOverviewRouteImport } from './routes/_auth/_app-shell/billing/$projectId/overview'
import { Route as AuthAppShellBillingProjectIdInvoicesRouteImport } from './routes/_auth/_app-shell/billing/$projectId/invoices'
import { Route as AuthAppShellBillingProjectIdHistoryRouteImport } from './routes/_auth/_app-shell/billing/$projectId/history'
import { Route as AuthAppShellAdminSubcategoriesSubCategoryIdRouteImport } from './routes/_auth/_app-shell/admin/subcategories/$subCategoryId'
import { Route as AuthAppShellAdminDesignTypesDesignTypeIdRouteImport } from './routes/_auth/_app-shell/admin/design-types/$designTypeId'
import { Route as AuthAppShellAdminMbcGuidelinesNewRouteImport } from './routes/_auth/_app-shell/admin/mbc/guidelines/new'
import { Route as AuthAppShellAdminMbcGuidelinesGuidelineIdRouteImport } from './routes/_auth/_app-shell/admin/mbc/guidelines/$guidelineId'
import { Route as AuthAppShellAdminMbcChecksNewRouteImport } from './routes/_auth/_app-shell/admin/mbc/checks/new'
import { Route as AuthAppShellAdminMbcChecksCheckIdRouteImport } from './routes/_auth/_app-shell/admin/mbc/checks/$checkId'

const SubscriptionSuccessRoute = SubscriptionSuccessRouteImport.update({
  id: '/subscription-success',
  path: '/subscription-success',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCallRoute = OnboardingCallRouteImport.update({
  id: '/onboarding-call',
  path: '/onboarding-call',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KickstarterCallRoute = KickstarterCallRouteImport.update({
  id: '/kickstarter-call',
  path: '/kickstarter-call',
  getParentRoute: () => rootRouteImport,
} as any)
const KickstarterRoute = KickstarterRouteImport.update({
  id: '/kickstarter',
  path: '/kickstarter',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatePasswordRoute = CreatePasswordRouteImport.update({
  id: '/create-password',
  path: '/create-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAppShellRoute = AuthAppShellRouteImport.update({
  id: '/_app-shell',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppShellMakeASuggestionRoute =
  AuthAppShellMakeASuggestionRouteImport.update({
    id: '/make-a-suggestion',
    path: '/make-a-suggestion',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellWhitelabelIndexRoute =
  AuthAppShellWhitelabelIndexRouteImport.update({
    id: '/whitelabel/',
    path: '/whitelabel/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellUsersIndexRoute = AuthAppShellUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellTrashIndexRoute = AuthAppShellTrashIndexRouteImport.update({
  id: '/trash/',
  path: '/trash/',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellTeamsIndexRoute = AuthAppShellTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellRequestsIndexRoute =
  AuthAppShellRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellPublishIndexRoute =
  AuthAppShellPublishIndexRouteImport.update({
    id: '/publish/',
    path: '/publish/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProjectsIndexRoute =
  AuthAppShellProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellNotificationsIndexRoute =
  AuthAppShellNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellMyFilesIndexRoute =
  AuthAppShellMyFilesIndexRouteImport.update({
    id: '/my-files/',
    path: '/my-files/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellIssuesReportsIndexRoute =
  AuthAppShellIssuesReportsIndexRouteImport.update({
    id: '/issues-reports/',
    path: '/issues-reports/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellDashboardIndexRoute =
  AuthAppShellDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellBrandsIndexRoute = AuthAppShellBrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellBillingIndexRoute =
  AuthAppShellBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellWhitelabelDashboardRoute =
  AuthAppShellWhitelabelDashboardRouteImport.update({
    id: '/whitelabel/dashboard',
    path: '/whitelabel/dashboard',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellWhitelabelCreateRoute =
  AuthAppShellWhitelabelCreateRouteImport.update({
    id: '/whitelabel/create',
    path: '/whitelabel/create',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellUsersCreateRoute = AuthAppShellUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellUserProfileRoute = AuthAppShellUserProfileRouteImport.update({
  id: '/user/profile',
  path: '/user/profile',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellTeamsCreateRoute = AuthAppShellTeamsCreateRouteImport.update({
  id: '/teams/create',
  path: '/teams/create',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellRequestsTemplateRoute =
  AuthAppShellRequestsTemplateRouteImport.update({
    id: '/requests/template',
    path: '/requests/template',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellRequestsPickTypeRoute =
  AuthAppShellRequestsPickTypeRouteImport.update({
    id: '/requests/pick-type',
    path: '/requests/pick-type',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellRequestsMbcReviewRoute =
  AuthAppShellRequestsMbcReviewRouteImport.update({
    id: '/requests/mbc-review',
    path: '/requests/mbc-review',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellRequestsMbcRoute = AuthAppShellRequestsMbcRouteImport.update({
  id: '/requests/mbc',
  path: '/requests/mbc',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellRequestsCreateRoute =
  AuthAppShellRequestsCreateRouteImport.update({
    id: '/requests/create',
    path: '/requests/create',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProjectsProjectIdRoute =
  AuthAppShellProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProjectAssociatedRequestsProjectIdRoute =
  AuthAppShellProjectAssociatedRequestsProjectIdRouteImport.update({
    id: '/project-associated-requests/$projectId',
    path: '/project-associated-requests/$projectId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProfileDesignerPreferenceRoute =
  AuthAppShellProfileDesignerPreferenceRouteImport.update({
    id: '/profile/designer-preference',
    path: '/profile/designer-preference',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellPaywallNoCreditsRoute =
  AuthAppShellPaywallNoCreditsRouteImport.update({
    id: '/paywall/no-credits',
    path: '/paywall/no-credits',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellPaywallExpiredSubscriptionRoute =
  AuthAppShellPaywallExpiredSubscriptionRouteImport.update({
    id: '/paywall/expired-subscription',
    path: '/paywall/expired-subscription',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellNotificationsSettingsRoute =
  AuthAppShellNotificationsSettingsRouteImport.update({
    id: '/notifications/settings',
    path: '/notifications/settings',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellMyFilesTemplateRoute =
  AuthAppShellMyFilesTemplateRouteImport.update({
    id: '/my-files/template',
    path: '/my-files/template',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellBrandsCreateRoute =
  AuthAppShellBrandsCreateRouteImport.update({
    id: '/brands/create',
    path: '/brands/create',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellBrandsBrandIdRoute =
  AuthAppShellBrandsBrandIdRouteImport.update({
    id: '/brands/$brandId',
    path: '/brands/$brandId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellBillingProjectIdRoute =
  AuthAppShellBillingProjectIdRouteImport.update({
    id: '/billing/$projectId',
    path: '/billing/$projectId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminConfidenceCheckerRoute =
  AuthAppShellAdminConfidenceCheckerRouteImport.update({
    id: '/admin/confidence-checker',
    path: '/admin/confidence-checker',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProjectsProjectIdIndexRoute =
  AuthAppShellProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppShellProjectsProjectIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdIndexRoute =
  AuthAppShellBrandsBrandIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBillingProjectIdIndexRoute =
  AuthAppShellBillingProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppShellBillingProjectIdRoute,
  } as any)
const AuthAppShellAdminSubcategoriesIndexRoute =
  AuthAppShellAdminSubcategoriesIndexRouteImport.update({
    id: '/admin/subcategories/',
    path: '/admin/subcategories/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminMbcIndexRoute =
  AuthAppShellAdminMbcIndexRouteImport.update({
    id: '/admin/mbc/',
    path: '/admin/mbc/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminDesignTypesIndexRoute =
  AuthAppShellAdminDesignTypesIndexRouteImport.update({
    id: '/admin/design-types/',
    path: '/admin/design-types/',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellWhitelabelConfigIdEditRoute =
  AuthAppShellWhitelabelConfigIdEditRouteImport.update({
    id: '/whitelabel/$configId/edit',
    path: '/whitelabel/$configId/edit',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellUsersUserIdEditRoute =
  AuthAppShellUsersUserIdEditRouteImport.update({
    id: '/users/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellTeamsIdEditRoute = AuthAppShellTeamsIdEditRouteImport.update({
  id: '/teams/$id/edit',
  path: '/teams/$id/edit',
  getParentRoute: () => AuthAppShellRoute,
} as any)
const AuthAppShellRequestsRequestIdEditRoute =
  AuthAppShellRequestsRequestIdEditRouteImport.update({
    id: '/requests/$requestId/edit',
    path: '/requests/$requestId/edit',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute =
  AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRouteImport.update({
    id: '/requests/$requestId/confidence-checker-summary',
    path: '/requests/$requestId/confidence-checker-summary',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellPublishPostsPostIdRoute =
  AuthAppShellPublishPostsPostIdRouteImport.update({
    id: '/publish/posts/$postId',
    path: '/publish/posts/$postId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellProjectsProjectIdUsersRoute =
  AuthAppShellProjectsProjectIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthAppShellProjectsProjectIdRoute,
  } as any)
const AuthAppShellProjectsProjectIdInternalNotesRoute =
  AuthAppShellProjectsProjectIdInternalNotesRouteImport.update({
    id: '/internal-notes',
    path: '/internal-notes',
    getParentRoute: () => AuthAppShellProjectsProjectIdRoute,
  } as any)
const AuthAppShellProjectsProjectIdEditRoute =
  AuthAppShellProjectsProjectIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppShellProjectsProjectIdRoute,
  } as any)
const AuthAppShellProjectsProjectIdBrandsRoute =
  AuthAppShellProjectsProjectIdBrandsRouteImport.update({
    id: '/brands',
    path: '/brands',
    getParentRoute: () => AuthAppShellProjectsProjectIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdVisualdirectionRoute =
  AuthAppShellBrandsBrandIdVisualdirectionRouteImport.update({
    id: '/visualdirection',
    path: '/visualdirection',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdRequestsRoute =
  AuthAppShellBrandsBrandIdRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdOverviewRoute =
  AuthAppShellBrandsBrandIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdKnowledgeRoute =
  AuthAppShellBrandsBrandIdKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdEditRoute =
  AuthAppShellBrandsBrandIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBrandsBrandIdSplatRoute =
  AuthAppShellBrandsBrandIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthAppShellBrandsBrandIdRoute,
  } as any)
const AuthAppShellBillingProjectIdPaymentMethodsRoute =
  AuthAppShellBillingProjectIdPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthAppShellBillingProjectIdRoute,
  } as any)
const AuthAppShellBillingProjectIdOverviewRoute =
  AuthAppShellBillingProjectIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthAppShellBillingProjectIdRoute,
  } as any)
const AuthAppShellBillingProjectIdInvoicesRoute =
  AuthAppShellBillingProjectIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthAppShellBillingProjectIdRoute,
  } as any)
const AuthAppShellBillingProjectIdHistoryRoute =
  AuthAppShellBillingProjectIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthAppShellBillingProjectIdRoute,
  } as any)
const AuthAppShellAdminSubcategoriesSubCategoryIdRoute =
  AuthAppShellAdminSubcategoriesSubCategoryIdRouteImport.update({
    id: '/admin/subcategories/$subCategoryId',
    path: '/admin/subcategories/$subCategoryId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminDesignTypesDesignTypeIdRoute =
  AuthAppShellAdminDesignTypesDesignTypeIdRouteImport.update({
    id: '/admin/design-types/$designTypeId',
    path: '/admin/design-types/$designTypeId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminMbcGuidelinesNewRoute =
  AuthAppShellAdminMbcGuidelinesNewRouteImport.update({
    id: '/admin/mbc/guidelines/new',
    path: '/admin/mbc/guidelines/new',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminMbcGuidelinesGuidelineIdRoute =
  AuthAppShellAdminMbcGuidelinesGuidelineIdRouteImport.update({
    id: '/admin/mbc/guidelines/$guidelineId',
    path: '/admin/mbc/guidelines/$guidelineId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminMbcChecksNewRoute =
  AuthAppShellAdminMbcChecksNewRouteImport.update({
    id: '/admin/mbc/checks/new',
    path: '/admin/mbc/checks/new',
    getParentRoute: () => AuthAppShellRoute,
  } as any)
const AuthAppShellAdminMbcChecksCheckIdRoute =
  AuthAppShellAdminMbcChecksCheckIdRouteImport.update({
    id: '/admin/mbc/checks/$checkId',
    path: '/admin/mbc/checks/$checkId',
    getParentRoute: () => AuthAppShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create-password': typeof CreatePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/kickstarter': typeof KickstarterRoute
  '/kickstarter-call': typeof KickstarterCallRoute
  '/login': typeof LoginRoute
  '/onboarding-call': typeof OnboardingCallRoute
  '/pricing': typeof PricingRoute
  '/subscription': typeof SubscriptionRoute
  '/subscription-success': typeof SubscriptionSuccessRoute
  '/make-a-suggestion': typeof AuthAppShellMakeASuggestionRoute
  '/admin/confidence-checker': typeof AuthAppShellAdminConfidenceCheckerRoute
  '/billing/$projectId': typeof AuthAppShellBillingProjectIdRouteWithChildren
  '/brands/$brandId': typeof AuthAppShellBrandsBrandIdRouteWithChildren
  '/brands/create': typeof AuthAppShellBrandsCreateRoute
  '/my-files/template': typeof AuthAppShellMyFilesTemplateRoute
  '/notifications/settings': typeof AuthAppShellNotificationsSettingsRoute
  '/paywall/expired-subscription': typeof AuthAppShellPaywallExpiredSubscriptionRoute
  '/paywall/no-credits': typeof AuthAppShellPaywallNoCreditsRoute
  '/profile/designer-preference': typeof AuthAppShellProfileDesignerPreferenceRoute
  '/project-associated-requests/$projectId': typeof AuthAppShellProjectAssociatedRequestsProjectIdRoute
  '/projects/$projectId': typeof AuthAppShellProjectsProjectIdRouteWithChildren
  '/requests/create': typeof AuthAppShellRequestsCreateRoute
  '/requests/mbc': typeof AuthAppShellRequestsMbcRoute
  '/requests/mbc-review': typeof AuthAppShellRequestsMbcReviewRoute
  '/requests/pick-type': typeof AuthAppShellRequestsPickTypeRoute
  '/requests/template': typeof AuthAppShellRequestsTemplateRoute
  '/teams/create': typeof AuthAppShellTeamsCreateRoute
  '/user/profile': typeof AuthAppShellUserProfileRoute
  '/users/create': typeof AuthAppShellUsersCreateRoute
  '/whitelabel/create': typeof AuthAppShellWhitelabelCreateRoute
  '/whitelabel/dashboard': typeof AuthAppShellWhitelabelDashboardRoute
  '/billing/': typeof AuthAppShellBillingIndexRoute
  '/brands/': typeof AuthAppShellBrandsIndexRoute
  '/dashboard/': typeof AuthAppShellDashboardIndexRoute
  '/issues-reports/': typeof AuthAppShellIssuesReportsIndexRoute
  '/my-files/': typeof AuthAppShellMyFilesIndexRoute
  '/notifications/': typeof AuthAppShellNotificationsIndexRoute
  '/projects/': typeof AuthAppShellProjectsIndexRoute
  '/publish/': typeof AuthAppShellPublishIndexRoute
  '/requests/': typeof AuthAppShellRequestsIndexRoute
  '/teams/': typeof AuthAppShellTeamsIndexRoute
  '/trash/': typeof AuthAppShellTrashIndexRoute
  '/users/': typeof AuthAppShellUsersIndexRoute
  '/whitelabel/': typeof AuthAppShellWhitelabelIndexRoute
  '/admin/design-types/$designTypeId': typeof AuthAppShellAdminDesignTypesDesignTypeIdRoute
  '/admin/subcategories/$subCategoryId': typeof AuthAppShellAdminSubcategoriesSubCategoryIdRoute
  '/billing/$projectId/history': typeof AuthAppShellBillingProjectIdHistoryRoute
  '/billing/$projectId/invoices': typeof AuthAppShellBillingProjectIdInvoicesRoute
  '/billing/$projectId/overview': typeof AuthAppShellBillingProjectIdOverviewRoute
  '/billing/$projectId/payment-methods': typeof AuthAppShellBillingProjectIdPaymentMethodsRoute
  '/brands/$brandId/$': typeof AuthAppShellBrandsBrandIdSplatRoute
  '/brands/$brandId/edit': typeof AuthAppShellBrandsBrandIdEditRoute
  '/brands/$brandId/knowledge': typeof AuthAppShellBrandsBrandIdKnowledgeRoute
  '/brands/$brandId/overview': typeof AuthAppShellBrandsBrandIdOverviewRoute
  '/brands/$brandId/requests': typeof AuthAppShellBrandsBrandIdRequestsRoute
  '/brands/$brandId/visualdirection': typeof AuthAppShellBrandsBrandIdVisualdirectionRoute
  '/projects/$projectId/brands': typeof AuthAppShellProjectsProjectIdBrandsRoute
  '/projects/$projectId/edit': typeof AuthAppShellProjectsProjectIdEditRoute
  '/projects/$projectId/internal-notes': typeof AuthAppShellProjectsProjectIdInternalNotesRoute
  '/projects/$projectId/users': typeof AuthAppShellProjectsProjectIdUsersRoute
  '/publish/posts/$postId': typeof AuthAppShellPublishPostsPostIdRoute
  '/requests/$requestId/confidence-checker-summary': typeof AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute
  '/requests/$requestId/edit': typeof AuthAppShellRequestsRequestIdEditRoute
  '/teams/$id/edit': typeof AuthAppShellTeamsIdEditRoute
  '/users/$userId/edit': typeof AuthAppShellUsersUserIdEditRoute
  '/whitelabel/$configId/edit': typeof AuthAppShellWhitelabelConfigIdEditRoute
  '/admin/design-types/': typeof AuthAppShellAdminDesignTypesIndexRoute
  '/admin/mbc/': typeof AuthAppShellAdminMbcIndexRoute
  '/admin/subcategories/': typeof AuthAppShellAdminSubcategoriesIndexRoute
  '/billing/$projectId/': typeof AuthAppShellBillingProjectIdIndexRoute
  '/brands/$brandId/': typeof AuthAppShellBrandsBrandIdIndexRoute
  '/projects/$projectId/': typeof AuthAppShellProjectsProjectIdIndexRoute
  '/admin/mbc/checks/$checkId': typeof AuthAppShellAdminMbcChecksCheckIdRoute
  '/admin/mbc/checks/new': typeof AuthAppShellAdminMbcChecksNewRoute
  '/admin/mbc/guidelines/$guidelineId': typeof AuthAppShellAdminMbcGuidelinesGuidelineIdRoute
  '/admin/mbc/guidelines/new': typeof AuthAppShellAdminMbcGuidelinesNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create-password': typeof CreatePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/kickstarter': typeof KickstarterRoute
  '/kickstarter-call': typeof KickstarterCallRoute
  '/login': typeof LoginRoute
  '/onboarding-call': typeof OnboardingCallRoute
  '/pricing': typeof PricingRoute
  '/subscription': typeof SubscriptionRoute
  '/subscription-success': typeof SubscriptionSuccessRoute
  '/make-a-suggestion': typeof AuthAppShellMakeASuggestionRoute
  '/admin/confidence-checker': typeof AuthAppShellAdminConfidenceCheckerRoute
  '/brands/create': typeof AuthAppShellBrandsCreateRoute
  '/my-files/template': typeof AuthAppShellMyFilesTemplateRoute
  '/notifications/settings': typeof AuthAppShellNotificationsSettingsRoute
  '/paywall/expired-subscription': typeof AuthAppShellPaywallExpiredSubscriptionRoute
  '/paywall/no-credits': typeof AuthAppShellPaywallNoCreditsRoute
  '/profile/designer-preference': typeof AuthAppShellProfileDesignerPreferenceRoute
  '/project-associated-requests/$projectId': typeof AuthAppShellProjectAssociatedRequestsProjectIdRoute
  '/requests/create': typeof AuthAppShellRequestsCreateRoute
  '/requests/mbc': typeof AuthAppShellRequestsMbcRoute
  '/requests/mbc-review': typeof AuthAppShellRequestsMbcReviewRoute
  '/requests/pick-type': typeof AuthAppShellRequestsPickTypeRoute
  '/requests/template': typeof AuthAppShellRequestsTemplateRoute
  '/teams/create': typeof AuthAppShellTeamsCreateRoute
  '/user/profile': typeof AuthAppShellUserProfileRoute
  '/users/create': typeof AuthAppShellUsersCreateRoute
  '/whitelabel/create': typeof AuthAppShellWhitelabelCreateRoute
  '/whitelabel/dashboard': typeof AuthAppShellWhitelabelDashboardRoute
  '/billing': typeof AuthAppShellBillingIndexRoute
  '/brands': typeof AuthAppShellBrandsIndexRoute
  '/dashboard': typeof AuthAppShellDashboardIndexRoute
  '/issues-reports': typeof AuthAppShellIssuesReportsIndexRoute
  '/my-files': typeof AuthAppShellMyFilesIndexRoute
  '/notifications': typeof AuthAppShellNotificationsIndexRoute
  '/projects': typeof AuthAppShellProjectsIndexRoute
  '/publish': typeof AuthAppShellPublishIndexRoute
  '/requests': typeof AuthAppShellRequestsIndexRoute
  '/teams': typeof AuthAppShellTeamsIndexRoute
  '/trash': typeof AuthAppShellTrashIndexRoute
  '/users': typeof AuthAppShellUsersIndexRoute
  '/whitelabel': typeof AuthAppShellWhitelabelIndexRoute
  '/admin/design-types/$designTypeId': typeof AuthAppShellAdminDesignTypesDesignTypeIdRoute
  '/admin/subcategories/$subCategoryId': typeof AuthAppShellAdminSubcategoriesSubCategoryIdRoute
  '/billing/$projectId/history': typeof AuthAppShellBillingProjectIdHistoryRoute
  '/billing/$projectId/invoices': typeof AuthAppShellBillingProjectIdInvoicesRoute
  '/billing/$projectId/overview': typeof AuthAppShellBillingProjectIdOverviewRoute
  '/billing/$projectId/payment-methods': typeof AuthAppShellBillingProjectIdPaymentMethodsRoute
  '/brands/$brandId/$': typeof AuthAppShellBrandsBrandIdSplatRoute
  '/brands/$brandId/edit': typeof AuthAppShellBrandsBrandIdEditRoute
  '/brands/$brandId/knowledge': typeof AuthAppShellBrandsBrandIdKnowledgeRoute
  '/brands/$brandId/overview': typeof AuthAppShellBrandsBrandIdOverviewRoute
  '/brands/$brandId/requests': typeof AuthAppShellBrandsBrandIdRequestsRoute
  '/brands/$brandId/visualdirection': typeof AuthAppShellBrandsBrandIdVisualdirectionRoute
  '/projects/$projectId/brands': typeof AuthAppShellProjectsProjectIdBrandsRoute
  '/projects/$projectId/edit': typeof AuthAppShellProjectsProjectIdEditRoute
  '/projects/$projectId/internal-notes': typeof AuthAppShellProjectsProjectIdInternalNotesRoute
  '/projects/$projectId/users': typeof AuthAppShellProjectsProjectIdUsersRoute
  '/publish/posts/$postId': typeof AuthAppShellPublishPostsPostIdRoute
  '/requests/$requestId/confidence-checker-summary': typeof AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute
  '/requests/$requestId/edit': typeof AuthAppShellRequestsRequestIdEditRoute
  '/teams/$id/edit': typeof AuthAppShellTeamsIdEditRoute
  '/users/$userId/edit': typeof AuthAppShellUsersUserIdEditRoute
  '/whitelabel/$configId/edit': typeof AuthAppShellWhitelabelConfigIdEditRoute
  '/admin/design-types': typeof AuthAppShellAdminDesignTypesIndexRoute
  '/admin/mbc': typeof AuthAppShellAdminMbcIndexRoute
  '/admin/subcategories': typeof AuthAppShellAdminSubcategoriesIndexRoute
  '/billing/$projectId': typeof AuthAppShellBillingProjectIdIndexRoute
  '/brands/$brandId': typeof AuthAppShellBrandsBrandIdIndexRoute
  '/projects/$projectId': typeof AuthAppShellProjectsProjectIdIndexRoute
  '/admin/mbc/checks/$checkId': typeof AuthAppShellAdminMbcChecksCheckIdRoute
  '/admin/mbc/checks/new': typeof AuthAppShellAdminMbcChecksNewRoute
  '/admin/mbc/guidelines/$guidelineId': typeof AuthAppShellAdminMbcGuidelinesGuidelineIdRoute
  '/admin/mbc/guidelines/new': typeof AuthAppShellAdminMbcGuidelinesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/create-password': typeof CreatePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/kickstarter': typeof KickstarterRoute
  '/kickstarter-call': typeof KickstarterCallRoute
  '/login': typeof LoginRoute
  '/onboarding-call': typeof OnboardingCallRoute
  '/pricing': typeof PricingRoute
  '/subscription': typeof SubscriptionRoute
  '/subscription-success': typeof SubscriptionSuccessRoute
  '/_auth/_app-shell': typeof AuthAppShellRouteWithChildren
  '/_auth/_app-shell/make-a-suggestion': typeof AuthAppShellMakeASuggestionRoute
  '/_auth/_app-shell/admin/confidence-checker': typeof AuthAppShellAdminConfidenceCheckerRoute
  '/_auth/_app-shell/billing/$projectId': typeof AuthAppShellBillingProjectIdRouteWithChildren
  '/_auth/_app-shell/brands/$brandId': typeof AuthAppShellBrandsBrandIdRouteWithChildren
  '/_auth/_app-shell/brands/create': typeof AuthAppShellBrandsCreateRoute
  '/_auth/_app-shell/my-files/template': typeof AuthAppShellMyFilesTemplateRoute
  '/_auth/_app-shell/notifications/settings': typeof AuthAppShellNotificationsSettingsRoute
  '/_auth/_app-shell/paywall/expired-subscription': typeof AuthAppShellPaywallExpiredSubscriptionRoute
  '/_auth/_app-shell/paywall/no-credits': typeof AuthAppShellPaywallNoCreditsRoute
  '/_auth/_app-shell/profile/designer-preference': typeof AuthAppShellProfileDesignerPreferenceRoute
  '/_auth/_app-shell/project-associated-requests/$projectId': typeof AuthAppShellProjectAssociatedRequestsProjectIdRoute
  '/_auth/_app-shell/projects/$projectId': typeof AuthAppShellProjectsProjectIdRouteWithChildren
  '/_auth/_app-shell/requests/create': typeof AuthAppShellRequestsCreateRoute
  '/_auth/_app-shell/requests/mbc': typeof AuthAppShellRequestsMbcRoute
  '/_auth/_app-shell/requests/mbc-review': typeof AuthAppShellRequestsMbcReviewRoute
  '/_auth/_app-shell/requests/pick-type': typeof AuthAppShellRequestsPickTypeRoute
  '/_auth/_app-shell/requests/template': typeof AuthAppShellRequestsTemplateRoute
  '/_auth/_app-shell/teams/create': typeof AuthAppShellTeamsCreateRoute
  '/_auth/_app-shell/user/profile': typeof AuthAppShellUserProfileRoute
  '/_auth/_app-shell/users/create': typeof AuthAppShellUsersCreateRoute
  '/_auth/_app-shell/whitelabel/create': typeof AuthAppShellWhitelabelCreateRoute
  '/_auth/_app-shell/whitelabel/dashboard': typeof AuthAppShellWhitelabelDashboardRoute
  '/_auth/_app-shell/billing/': typeof AuthAppShellBillingIndexRoute
  '/_auth/_app-shell/brands/': typeof AuthAppShellBrandsIndexRoute
  '/_auth/_app-shell/dashboard/': typeof AuthAppShellDashboardIndexRoute
  '/_auth/_app-shell/issues-reports/': typeof AuthAppShellIssuesReportsIndexRoute
  '/_auth/_app-shell/my-files/': typeof AuthAppShellMyFilesIndexRoute
  '/_auth/_app-shell/notifications/': typeof AuthAppShellNotificationsIndexRoute
  '/_auth/_app-shell/projects/': typeof AuthAppShellProjectsIndexRoute
  '/_auth/_app-shell/publish/': typeof AuthAppShellPublishIndexRoute
  '/_auth/_app-shell/requests/': typeof AuthAppShellRequestsIndexRoute
  '/_auth/_app-shell/teams/': typeof AuthAppShellTeamsIndexRoute
  '/_auth/_app-shell/trash/': typeof AuthAppShellTrashIndexRoute
  '/_auth/_app-shell/users/': typeof AuthAppShellUsersIndexRoute
  '/_auth/_app-shell/whitelabel/': typeof AuthAppShellWhitelabelIndexRoute
  '/_auth/_app-shell/admin/design-types/$designTypeId': typeof AuthAppShellAdminDesignTypesDesignTypeIdRoute
  '/_auth/_app-shell/admin/subcategories/$subCategoryId': typeof AuthAppShellAdminSubcategoriesSubCategoryIdRoute
  '/_auth/_app-shell/billing/$projectId/history': typeof AuthAppShellBillingProjectIdHistoryRoute
  '/_auth/_app-shell/billing/$projectId/invoices': typeof AuthAppShellBillingProjectIdInvoicesRoute
  '/_auth/_app-shell/billing/$projectId/overview': typeof AuthAppShellBillingProjectIdOverviewRoute
  '/_auth/_app-shell/billing/$projectId/payment-methods': typeof AuthAppShellBillingProjectIdPaymentMethodsRoute
  '/_auth/_app-shell/brands/$brandId/$': typeof AuthAppShellBrandsBrandIdSplatRoute
  '/_auth/_app-shell/brands/$brandId/edit': typeof AuthAppShellBrandsBrandIdEditRoute
  '/_auth/_app-shell/brands/$brandId/knowledge': typeof AuthAppShellBrandsBrandIdKnowledgeRoute
  '/_auth/_app-shell/brands/$brandId/overview': typeof AuthAppShellBrandsBrandIdOverviewRoute
  '/_auth/_app-shell/brands/$brandId/requests': typeof AuthAppShellBrandsBrandIdRequestsRoute
  '/_auth/_app-shell/brands/$brandId/visualdirection': typeof AuthAppShellBrandsBrandIdVisualdirectionRoute
  '/_auth/_app-shell/projects/$projectId/brands': typeof AuthAppShellProjectsProjectIdBrandsRoute
  '/_auth/_app-shell/projects/$projectId/edit': typeof AuthAppShellProjectsProjectIdEditRoute
  '/_auth/_app-shell/projects/$projectId/internal-notes': typeof AuthAppShellProjectsProjectIdInternalNotesRoute
  '/_auth/_app-shell/projects/$projectId/users': typeof AuthAppShellProjectsProjectIdUsersRoute
  '/_auth/_app-shell/publish/posts/$postId': typeof AuthAppShellPublishPostsPostIdRoute
  '/_auth/_app-shell/requests/$requestId/confidence-checker-summary': typeof AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute
  '/_auth/_app-shell/requests/$requestId/edit': typeof AuthAppShellRequestsRequestIdEditRoute
  '/_auth/_app-shell/teams/$id/edit': typeof AuthAppShellTeamsIdEditRoute
  '/_auth/_app-shell/users/$userId/edit': typeof AuthAppShellUsersUserIdEditRoute
  '/_auth/_app-shell/whitelabel/$configId/edit': typeof AuthAppShellWhitelabelConfigIdEditRoute
  '/_auth/_app-shell/admin/design-types/': typeof AuthAppShellAdminDesignTypesIndexRoute
  '/_auth/_app-shell/admin/mbc/': typeof AuthAppShellAdminMbcIndexRoute
  '/_auth/_app-shell/admin/subcategories/': typeof AuthAppShellAdminSubcategoriesIndexRoute
  '/_auth/_app-shell/billing/$projectId/': typeof AuthAppShellBillingProjectIdIndexRoute
  '/_auth/_app-shell/brands/$brandId/': typeof AuthAppShellBrandsBrandIdIndexRoute
  '/_auth/_app-shell/projects/$projectId/': typeof AuthAppShellProjectsProjectIdIndexRoute
  '/_auth/_app-shell/admin/mbc/checks/$checkId': typeof AuthAppShellAdminMbcChecksCheckIdRoute
  '/_auth/_app-shell/admin/mbc/checks/new': typeof AuthAppShellAdminMbcChecksNewRoute
  '/_auth/_app-shell/admin/mbc/guidelines/$guidelineId': typeof AuthAppShellAdminMbcGuidelinesGuidelineIdRoute
  '/_auth/_app-shell/admin/mbc/guidelines/new': typeof AuthAppShellAdminMbcGuidelinesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create-password'
    | '/forgot-password'
    | '/kickstarter'
    | '/kickstarter-call'
    | '/login'
    | '/onboarding-call'
    | '/pricing'
    | '/subscription'
    | '/subscription-success'
    | '/make-a-suggestion'
    | '/admin/confidence-checker'
    | '/billing/$projectId'
    | '/brands/$brandId'
    | '/brands/create'
    | '/my-files/template'
    | '/notifications/settings'
    | '/paywall/expired-subscription'
    | '/paywall/no-credits'
    | '/profile/designer-preference'
    | '/project-associated-requests/$projectId'
    | '/projects/$projectId'
    | '/requests/create'
    | '/requests/mbc'
    | '/requests/mbc-review'
    | '/requests/pick-type'
    | '/requests/template'
    | '/teams/create'
    | '/user/profile'
    | '/users/create'
    | '/whitelabel/create'
    | '/whitelabel/dashboard'
    | '/billing/'
    | '/brands/'
    | '/dashboard/'
    | '/issues-reports/'
    | '/my-files/'
    | '/notifications/'
    | '/projects/'
    | '/publish/'
    | '/requests/'
    | '/teams/'
    | '/trash/'
    | '/users/'
    | '/whitelabel/'
    | '/admin/design-types/$designTypeId'
    | '/admin/subcategories/$subCategoryId'
    | '/billing/$projectId/history'
    | '/billing/$projectId/invoices'
    | '/billing/$projectId/overview'
    | '/billing/$projectId/payment-methods'
    | '/brands/$brandId/$'
    | '/brands/$brandId/edit'
    | '/brands/$brandId/knowledge'
    | '/brands/$brandId/overview'
    | '/brands/$brandId/requests'
    | '/brands/$brandId/visualdirection'
    | '/projects/$projectId/brands'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/internal-notes'
    | '/projects/$projectId/users'
    | '/publish/posts/$postId'
    | '/requests/$requestId/confidence-checker-summary'
    | '/requests/$requestId/edit'
    | '/teams/$id/edit'
    | '/users/$userId/edit'
    | '/whitelabel/$configId/edit'
    | '/admin/design-types/'
    | '/admin/mbc/'
    | '/admin/subcategories/'
    | '/billing/$projectId/'
    | '/brands/$brandId/'
    | '/projects/$projectId/'
    | '/admin/mbc/checks/$checkId'
    | '/admin/mbc/checks/new'
    | '/admin/mbc/guidelines/$guidelineId'
    | '/admin/mbc/guidelines/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create-password'
    | '/forgot-password'
    | '/kickstarter'
    | '/kickstarter-call'
    | '/login'
    | '/onboarding-call'
    | '/pricing'
    | '/subscription'
    | '/subscription-success'
    | '/make-a-suggestion'
    | '/admin/confidence-checker'
    | '/brands/create'
    | '/my-files/template'
    | '/notifications/settings'
    | '/paywall/expired-subscription'
    | '/paywall/no-credits'
    | '/profile/designer-preference'
    | '/project-associated-requests/$projectId'
    | '/requests/create'
    | '/requests/mbc'
    | '/requests/mbc-review'
    | '/requests/pick-type'
    | '/requests/template'
    | '/teams/create'
    | '/user/profile'
    | '/users/create'
    | '/whitelabel/create'
    | '/whitelabel/dashboard'
    | '/billing'
    | '/brands'
    | '/dashboard'
    | '/issues-reports'
    | '/my-files'
    | '/notifications'
    | '/projects'
    | '/publish'
    | '/requests'
    | '/teams'
    | '/trash'
    | '/users'
    | '/whitelabel'
    | '/admin/design-types/$designTypeId'
    | '/admin/subcategories/$subCategoryId'
    | '/billing/$projectId/history'
    | '/billing/$projectId/invoices'
    | '/billing/$projectId/overview'
    | '/billing/$projectId/payment-methods'
    | '/brands/$brandId/$'
    | '/brands/$brandId/edit'
    | '/brands/$brandId/knowledge'
    | '/brands/$brandId/overview'
    | '/brands/$brandId/requests'
    | '/brands/$brandId/visualdirection'
    | '/projects/$projectId/brands'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/internal-notes'
    | '/projects/$projectId/users'
    | '/publish/posts/$postId'
    | '/requests/$requestId/confidence-checker-summary'
    | '/requests/$requestId/edit'
    | '/teams/$id/edit'
    | '/users/$userId/edit'
    | '/whitelabel/$configId/edit'
    | '/admin/design-types'
    | '/admin/mbc'
    | '/admin/subcategories'
    | '/billing/$projectId'
    | '/brands/$brandId'
    | '/projects/$projectId'
    | '/admin/mbc/checks/$checkId'
    | '/admin/mbc/checks/new'
    | '/admin/mbc/guidelines/$guidelineId'
    | '/admin/mbc/guidelines/new'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/create-password'
    | '/forgot-password'
    | '/kickstarter'
    | '/kickstarter-call'
    | '/login'
    | '/onboarding-call'
    | '/pricing'
    | '/subscription'
    | '/subscription-success'
    | '/_auth/_app-shell'
    | '/_auth/_app-shell/make-a-suggestion'
    | '/_auth/_app-shell/admin/confidence-checker'
    | '/_auth/_app-shell/billing/$projectId'
    | '/_auth/_app-shell/brands/$brandId'
    | '/_auth/_app-shell/brands/create'
    | '/_auth/_app-shell/my-files/template'
    | '/_auth/_app-shell/notifications/settings'
    | '/_auth/_app-shell/paywall/expired-subscription'
    | '/_auth/_app-shell/paywall/no-credits'
    | '/_auth/_app-shell/profile/designer-preference'
    | '/_auth/_app-shell/project-associated-requests/$projectId'
    | '/_auth/_app-shell/projects/$projectId'
    | '/_auth/_app-shell/requests/create'
    | '/_auth/_app-shell/requests/mbc'
    | '/_auth/_app-shell/requests/mbc-review'
    | '/_auth/_app-shell/requests/pick-type'
    | '/_auth/_app-shell/requests/template'
    | '/_auth/_app-shell/teams/create'
    | '/_auth/_app-shell/user/profile'
    | '/_auth/_app-shell/users/create'
    | '/_auth/_app-shell/whitelabel/create'
    | '/_auth/_app-shell/whitelabel/dashboard'
    | '/_auth/_app-shell/billing/'
    | '/_auth/_app-shell/brands/'
    | '/_auth/_app-shell/dashboard/'
    | '/_auth/_app-shell/issues-reports/'
    | '/_auth/_app-shell/my-files/'
    | '/_auth/_app-shell/notifications/'
    | '/_auth/_app-shell/projects/'
    | '/_auth/_app-shell/publish/'
    | '/_auth/_app-shell/requests/'
    | '/_auth/_app-shell/teams/'
    | '/_auth/_app-shell/trash/'
    | '/_auth/_app-shell/users/'
    | '/_auth/_app-shell/whitelabel/'
    | '/_auth/_app-shell/admin/design-types/$designTypeId'
    | '/_auth/_app-shell/admin/subcategories/$subCategoryId'
    | '/_auth/_app-shell/billing/$projectId/history'
    | '/_auth/_app-shell/billing/$projectId/invoices'
    | '/_auth/_app-shell/billing/$projectId/overview'
    | '/_auth/_app-shell/billing/$projectId/payment-methods'
    | '/_auth/_app-shell/brands/$brandId/$'
    | '/_auth/_app-shell/brands/$brandId/edit'
    | '/_auth/_app-shell/brands/$brandId/knowledge'
    | '/_auth/_app-shell/brands/$brandId/overview'
    | '/_auth/_app-shell/brands/$brandId/requests'
    | '/_auth/_app-shell/brands/$brandId/visualdirection'
    | '/_auth/_app-shell/projects/$projectId/brands'
    | '/_auth/_app-shell/projects/$projectId/edit'
    | '/_auth/_app-shell/projects/$projectId/internal-notes'
    | '/_auth/_app-shell/projects/$projectId/users'
    | '/_auth/_app-shell/publish/posts/$postId'
    | '/_auth/_app-shell/requests/$requestId/confidence-checker-summary'
    | '/_auth/_app-shell/requests/$requestId/edit'
    | '/_auth/_app-shell/teams/$id/edit'
    | '/_auth/_app-shell/users/$userId/edit'
    | '/_auth/_app-shell/whitelabel/$configId/edit'
    | '/_auth/_app-shell/admin/design-types/'
    | '/_auth/_app-shell/admin/mbc/'
    | '/_auth/_app-shell/admin/subcategories/'
    | '/_auth/_app-shell/billing/$projectId/'
    | '/_auth/_app-shell/brands/$brandId/'
    | '/_auth/_app-shell/projects/$projectId/'
    | '/_auth/_app-shell/admin/mbc/checks/$checkId'
    | '/_auth/_app-shell/admin/mbc/checks/new'
    | '/_auth/_app-shell/admin/mbc/guidelines/$guidelineId'
    | '/_auth/_app-shell/admin/mbc/guidelines/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  CreatePasswordRoute: typeof CreatePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  KickstarterRoute: typeof KickstarterRoute
  KickstarterCallRoute: typeof KickstarterCallRoute
  LoginRoute: typeof LoginRoute
  OnboardingCallRoute: typeof OnboardingCallRoute
  PricingRoute: typeof PricingRoute
  SubscriptionRoute: typeof SubscriptionRoute
  SubscriptionSuccessRoute: typeof SubscriptionSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscription-success': {
      id: '/subscription-success'
      path: '/subscription-success'
      fullPath: '/subscription-success'
      preLoaderRoute: typeof SubscriptionSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding-call': {
      id: '/onboarding-call'
      path: '/onboarding-call'
      fullPath: '/onboarding-call'
      preLoaderRoute: typeof OnboardingCallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kickstarter-call': {
      id: '/kickstarter-call'
      path: '/kickstarter-call'
      fullPath: '/kickstarter-call'
      preLoaderRoute: typeof KickstarterCallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kickstarter': {
      id: '/kickstarter'
      path: '/kickstarter'
      fullPath: '/kickstarter'
      preLoaderRoute: typeof KickstarterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-password': {
      id: '/create-password'
      path: '/create-password'
      fullPath: '/create-password'
      preLoaderRoute: typeof CreatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_app-shell': {
      id: '/_auth/_app-shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAppShellRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_app-shell/make-a-suggestion': {
      id: '/_auth/_app-shell/make-a-suggestion'
      path: '/make-a-suggestion'
      fullPath: '/make-a-suggestion'
      preLoaderRoute: typeof AuthAppShellMakeASuggestionRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/whitelabel/': {
      id: '/_auth/_app-shell/whitelabel/'
      path: '/whitelabel'
      fullPath: '/whitelabel/'
      preLoaderRoute: typeof AuthAppShellWhitelabelIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/users/': {
      id: '/_auth/_app-shell/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthAppShellUsersIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/trash/': {
      id: '/_auth/_app-shell/trash/'
      path: '/trash'
      fullPath: '/trash/'
      preLoaderRoute: typeof AuthAppShellTrashIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/teams/': {
      id: '/_auth/_app-shell/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof AuthAppShellTeamsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/': {
      id: '/_auth/_app-shell/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof AuthAppShellRequestsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/publish/': {
      id: '/_auth/_app-shell/publish/'
      path: '/publish'
      fullPath: '/publish/'
      preLoaderRoute: typeof AuthAppShellPublishIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/projects/': {
      id: '/_auth/_app-shell/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthAppShellProjectsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/notifications/': {
      id: '/_auth/_app-shell/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthAppShellNotificationsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/my-files/': {
      id: '/_auth/_app-shell/my-files/'
      path: '/my-files'
      fullPath: '/my-files/'
      preLoaderRoute: typeof AuthAppShellMyFilesIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/issues-reports/': {
      id: '/_auth/_app-shell/issues-reports/'
      path: '/issues-reports'
      fullPath: '/issues-reports/'
      preLoaderRoute: typeof AuthAppShellIssuesReportsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/dashboard/': {
      id: '/_auth/_app-shell/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthAppShellDashboardIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/brands/': {
      id: '/_auth/_app-shell/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof AuthAppShellBrandsIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/billing/': {
      id: '/_auth/_app-shell/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthAppShellBillingIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/whitelabel/dashboard': {
      id: '/_auth/_app-shell/whitelabel/dashboard'
      path: '/whitelabel/dashboard'
      fullPath: '/whitelabel/dashboard'
      preLoaderRoute: typeof AuthAppShellWhitelabelDashboardRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/whitelabel/create': {
      id: '/_auth/_app-shell/whitelabel/create'
      path: '/whitelabel/create'
      fullPath: '/whitelabel/create'
      preLoaderRoute: typeof AuthAppShellWhitelabelCreateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/users/create': {
      id: '/_auth/_app-shell/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AuthAppShellUsersCreateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/user/profile': {
      id: '/_auth/_app-shell/user/profile'
      path: '/user/profile'
      fullPath: '/user/profile'
      preLoaderRoute: typeof AuthAppShellUserProfileRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/teams/create': {
      id: '/_auth/_app-shell/teams/create'
      path: '/teams/create'
      fullPath: '/teams/create'
      preLoaderRoute: typeof AuthAppShellTeamsCreateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/template': {
      id: '/_auth/_app-shell/requests/template'
      path: '/requests/template'
      fullPath: '/requests/template'
      preLoaderRoute: typeof AuthAppShellRequestsTemplateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/pick-type': {
      id: '/_auth/_app-shell/requests/pick-type'
      path: '/requests/pick-type'
      fullPath: '/requests/pick-type'
      preLoaderRoute: typeof AuthAppShellRequestsPickTypeRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/mbc-review': {
      id: '/_auth/_app-shell/requests/mbc-review'
      path: '/requests/mbc-review'
      fullPath: '/requests/mbc-review'
      preLoaderRoute: typeof AuthAppShellRequestsMbcReviewRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/mbc': {
      id: '/_auth/_app-shell/requests/mbc'
      path: '/requests/mbc'
      fullPath: '/requests/mbc'
      preLoaderRoute: typeof AuthAppShellRequestsMbcRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/create': {
      id: '/_auth/_app-shell/requests/create'
      path: '/requests/create'
      fullPath: '/requests/create'
      preLoaderRoute: typeof AuthAppShellRequestsCreateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/projects/$projectId': {
      id: '/_auth/_app-shell/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/project-associated-requests/$projectId': {
      id: '/_auth/_app-shell/project-associated-requests/$projectId'
      path: '/project-associated-requests/$projectId'
      fullPath: '/project-associated-requests/$projectId'
      preLoaderRoute: typeof AuthAppShellProjectAssociatedRequestsProjectIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/profile/designer-preference': {
      id: '/_auth/_app-shell/profile/designer-preference'
      path: '/profile/designer-preference'
      fullPath: '/profile/designer-preference'
      preLoaderRoute: typeof AuthAppShellProfileDesignerPreferenceRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/paywall/no-credits': {
      id: '/_auth/_app-shell/paywall/no-credits'
      path: '/paywall/no-credits'
      fullPath: '/paywall/no-credits'
      preLoaderRoute: typeof AuthAppShellPaywallNoCreditsRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/paywall/expired-subscription': {
      id: '/_auth/_app-shell/paywall/expired-subscription'
      path: '/paywall/expired-subscription'
      fullPath: '/paywall/expired-subscription'
      preLoaderRoute: typeof AuthAppShellPaywallExpiredSubscriptionRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/notifications/settings': {
      id: '/_auth/_app-shell/notifications/settings'
      path: '/notifications/settings'
      fullPath: '/notifications/settings'
      preLoaderRoute: typeof AuthAppShellNotificationsSettingsRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/my-files/template': {
      id: '/_auth/_app-shell/my-files/template'
      path: '/my-files/template'
      fullPath: '/my-files/template'
      preLoaderRoute: typeof AuthAppShellMyFilesTemplateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/brands/create': {
      id: '/_auth/_app-shell/brands/create'
      path: '/brands/create'
      fullPath: '/brands/create'
      preLoaderRoute: typeof AuthAppShellBrandsCreateRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/brands/$brandId': {
      id: '/_auth/_app-shell/brands/$brandId'
      path: '/brands/$brandId'
      fullPath: '/brands/$brandId'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/billing/$projectId': {
      id: '/_auth/_app-shell/billing/$projectId'
      path: '/billing/$projectId'
      fullPath: '/billing/$projectId'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/confidence-checker': {
      id: '/_auth/_app-shell/admin/confidence-checker'
      path: '/admin/confidence-checker'
      fullPath: '/admin/confidence-checker'
      preLoaderRoute: typeof AuthAppShellAdminConfidenceCheckerRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/projects/$projectId/': {
      id: '/_auth/_app-shell/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthAppShellProjectsProjectIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/': {
      id: '/_auth/_app-shell/brands/$brandId/'
      path: '/'
      fullPath: '/brands/$brandId/'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdIndexRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/billing/$projectId/': {
      id: '/_auth/_app-shell/billing/$projectId/'
      path: '/'
      fullPath: '/billing/$projectId/'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdIndexRouteImport
      parentRoute: typeof AuthAppShellBillingProjectIdRoute
    }
    '/_auth/_app-shell/admin/subcategories/': {
      id: '/_auth/_app-shell/admin/subcategories/'
      path: '/admin/subcategories'
      fullPath: '/admin/subcategories/'
      preLoaderRoute: typeof AuthAppShellAdminSubcategoriesIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/mbc/': {
      id: '/_auth/_app-shell/admin/mbc/'
      path: '/admin/mbc'
      fullPath: '/admin/mbc/'
      preLoaderRoute: typeof AuthAppShellAdminMbcIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/design-types/': {
      id: '/_auth/_app-shell/admin/design-types/'
      path: '/admin/design-types'
      fullPath: '/admin/design-types/'
      preLoaderRoute: typeof AuthAppShellAdminDesignTypesIndexRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/whitelabel/$configId/edit': {
      id: '/_auth/_app-shell/whitelabel/$configId/edit'
      path: '/whitelabel/$configId/edit'
      fullPath: '/whitelabel/$configId/edit'
      preLoaderRoute: typeof AuthAppShellWhitelabelConfigIdEditRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/users/$userId/edit': {
      id: '/_auth/_app-shell/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AuthAppShellUsersUserIdEditRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/teams/$id/edit': {
      id: '/_auth/_app-shell/teams/$id/edit'
      path: '/teams/$id/edit'
      fullPath: '/teams/$id/edit'
      preLoaderRoute: typeof AuthAppShellTeamsIdEditRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/$requestId/edit': {
      id: '/_auth/_app-shell/requests/$requestId/edit'
      path: '/requests/$requestId/edit'
      fullPath: '/requests/$requestId/edit'
      preLoaderRoute: typeof AuthAppShellRequestsRequestIdEditRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/requests/$requestId/confidence-checker-summary': {
      id: '/_auth/_app-shell/requests/$requestId/confidence-checker-summary'
      path: '/requests/$requestId/confidence-checker-summary'
      fullPath: '/requests/$requestId/confidence-checker-summary'
      preLoaderRoute: typeof AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/publish/posts/$postId': {
      id: '/_auth/_app-shell/publish/posts/$postId'
      path: '/publish/posts/$postId'
      fullPath: '/publish/posts/$postId'
      preLoaderRoute: typeof AuthAppShellPublishPostsPostIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/projects/$projectId/users': {
      id: '/_auth/_app-shell/projects/$projectId/users'
      path: '/users'
      fullPath: '/projects/$projectId/users'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdUsersRouteImport
      parentRoute: typeof AuthAppShellProjectsProjectIdRoute
    }
    '/_auth/_app-shell/projects/$projectId/internal-notes': {
      id: '/_auth/_app-shell/projects/$projectId/internal-notes'
      path: '/internal-notes'
      fullPath: '/projects/$projectId/internal-notes'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdInternalNotesRouteImport
      parentRoute: typeof AuthAppShellProjectsProjectIdRoute
    }
    '/_auth/_app-shell/projects/$projectId/edit': {
      id: '/_auth/_app-shell/projects/$projectId/edit'
      path: '/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthAppShellProjectsProjectIdRoute
    }
    '/_auth/_app-shell/projects/$projectId/brands': {
      id: '/_auth/_app-shell/projects/$projectId/brands'
      path: '/brands'
      fullPath: '/projects/$projectId/brands'
      preLoaderRoute: typeof AuthAppShellProjectsProjectIdBrandsRouteImport
      parentRoute: typeof AuthAppShellProjectsProjectIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/visualdirection': {
      id: '/_auth/_app-shell/brands/$brandId/visualdirection'
      path: '/visualdirection'
      fullPath: '/brands/$brandId/visualdirection'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdVisualdirectionRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/requests': {
      id: '/_auth/_app-shell/brands/$brandId/requests'
      path: '/requests'
      fullPath: '/brands/$brandId/requests'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdRequestsRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/overview': {
      id: '/_auth/_app-shell/brands/$brandId/overview'
      path: '/overview'
      fullPath: '/brands/$brandId/overview'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdOverviewRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/knowledge': {
      id: '/_auth/_app-shell/brands/$brandId/knowledge'
      path: '/knowledge'
      fullPath: '/brands/$brandId/knowledge'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdKnowledgeRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/edit': {
      id: '/_auth/_app-shell/brands/$brandId/edit'
      path: '/edit'
      fullPath: '/brands/$brandId/edit'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdEditRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/brands/$brandId/$': {
      id: '/_auth/_app-shell/brands/$brandId/$'
      path: '/$'
      fullPath: '/brands/$brandId/$'
      preLoaderRoute: typeof AuthAppShellBrandsBrandIdSplatRouteImport
      parentRoute: typeof AuthAppShellBrandsBrandIdRoute
    }
    '/_auth/_app-shell/billing/$projectId/payment-methods': {
      id: '/_auth/_app-shell/billing/$projectId/payment-methods'
      path: '/payment-methods'
      fullPath: '/billing/$projectId/payment-methods'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdPaymentMethodsRouteImport
      parentRoute: typeof AuthAppShellBillingProjectIdRoute
    }
    '/_auth/_app-shell/billing/$projectId/overview': {
      id: '/_auth/_app-shell/billing/$projectId/overview'
      path: '/overview'
      fullPath: '/billing/$projectId/overview'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdOverviewRouteImport
      parentRoute: typeof AuthAppShellBillingProjectIdRoute
    }
    '/_auth/_app-shell/billing/$projectId/invoices': {
      id: '/_auth/_app-shell/billing/$projectId/invoices'
      path: '/invoices'
      fullPath: '/billing/$projectId/invoices'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdInvoicesRouteImport
      parentRoute: typeof AuthAppShellBillingProjectIdRoute
    }
    '/_auth/_app-shell/billing/$projectId/history': {
      id: '/_auth/_app-shell/billing/$projectId/history'
      path: '/history'
      fullPath: '/billing/$projectId/history'
      preLoaderRoute: typeof AuthAppShellBillingProjectIdHistoryRouteImport
      parentRoute: typeof AuthAppShellBillingProjectIdRoute
    }
    '/_auth/_app-shell/admin/subcategories/$subCategoryId': {
      id: '/_auth/_app-shell/admin/subcategories/$subCategoryId'
      path: '/admin/subcategories/$subCategoryId'
      fullPath: '/admin/subcategories/$subCategoryId'
      preLoaderRoute: typeof AuthAppShellAdminSubcategoriesSubCategoryIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/design-types/$designTypeId': {
      id: '/_auth/_app-shell/admin/design-types/$designTypeId'
      path: '/admin/design-types/$designTypeId'
      fullPath: '/admin/design-types/$designTypeId'
      preLoaderRoute: typeof AuthAppShellAdminDesignTypesDesignTypeIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/mbc/guidelines/new': {
      id: '/_auth/_app-shell/admin/mbc/guidelines/new'
      path: '/admin/mbc/guidelines/new'
      fullPath: '/admin/mbc/guidelines/new'
      preLoaderRoute: typeof AuthAppShellAdminMbcGuidelinesNewRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/mbc/guidelines/$guidelineId': {
      id: '/_auth/_app-shell/admin/mbc/guidelines/$guidelineId'
      path: '/admin/mbc/guidelines/$guidelineId'
      fullPath: '/admin/mbc/guidelines/$guidelineId'
      preLoaderRoute: typeof AuthAppShellAdminMbcGuidelinesGuidelineIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/mbc/checks/new': {
      id: '/_auth/_app-shell/admin/mbc/checks/new'
      path: '/admin/mbc/checks/new'
      fullPath: '/admin/mbc/checks/new'
      preLoaderRoute: typeof AuthAppShellAdminMbcChecksNewRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
    '/_auth/_app-shell/admin/mbc/checks/$checkId': {
      id: '/_auth/_app-shell/admin/mbc/checks/$checkId'
      path: '/admin/mbc/checks/$checkId'
      fullPath: '/admin/mbc/checks/$checkId'
      preLoaderRoute: typeof AuthAppShellAdminMbcChecksCheckIdRouteImport
      parentRoute: typeof AuthAppShellRoute
    }
  }
}

interface AuthAppShellBillingProjectIdRouteChildren {
  AuthAppShellBillingProjectIdHistoryRoute: typeof AuthAppShellBillingProjectIdHistoryRoute
  AuthAppShellBillingProjectIdInvoicesRoute: typeof AuthAppShellBillingProjectIdInvoicesRoute
  AuthAppShellBillingProjectIdOverviewRoute: typeof AuthAppShellBillingProjectIdOverviewRoute
  AuthAppShellBillingProjectIdPaymentMethodsRoute: typeof AuthAppShellBillingProjectIdPaymentMethodsRoute
  AuthAppShellBillingProjectIdIndexRoute: typeof AuthAppShellBillingProjectIdIndexRoute
}

const AuthAppShellBillingProjectIdRouteChildren: AuthAppShellBillingProjectIdRouteChildren =
  {
    AuthAppShellBillingProjectIdHistoryRoute:
      AuthAppShellBillingProjectIdHistoryRoute,
    AuthAppShellBillingProjectIdInvoicesRoute:
      AuthAppShellBillingProjectIdInvoicesRoute,
    AuthAppShellBillingProjectIdOverviewRoute:
      AuthAppShellBillingProjectIdOverviewRoute,
    AuthAppShellBillingProjectIdPaymentMethodsRoute:
      AuthAppShellBillingProjectIdPaymentMethodsRoute,
    AuthAppShellBillingProjectIdIndexRoute:
      AuthAppShellBillingProjectIdIndexRoute,
  }

const AuthAppShellBillingProjectIdRouteWithChildren =
  AuthAppShellBillingProjectIdRoute._addFileChildren(
    AuthAppShellBillingProjectIdRouteChildren,
  )

interface AuthAppShellBrandsBrandIdRouteChildren {
  AuthAppShellBrandsBrandIdSplatRoute: typeof AuthAppShellBrandsBrandIdSplatRoute
  AuthAppShellBrandsBrandIdEditRoute: typeof AuthAppShellBrandsBrandIdEditRoute
  AuthAppShellBrandsBrandIdKnowledgeRoute: typeof AuthAppShellBrandsBrandIdKnowledgeRoute
  AuthAppShellBrandsBrandIdOverviewRoute: typeof AuthAppShellBrandsBrandIdOverviewRoute
  AuthAppShellBrandsBrandIdRequestsRoute: typeof AuthAppShellBrandsBrandIdRequestsRoute
  AuthAppShellBrandsBrandIdVisualdirectionRoute: typeof AuthAppShellBrandsBrandIdVisualdirectionRoute
  AuthAppShellBrandsBrandIdIndexRoute: typeof AuthAppShellBrandsBrandIdIndexRoute
}

const AuthAppShellBrandsBrandIdRouteChildren: AuthAppShellBrandsBrandIdRouteChildren =
  {
    AuthAppShellBrandsBrandIdSplatRoute: AuthAppShellBrandsBrandIdSplatRoute,
    AuthAppShellBrandsBrandIdEditRoute: AuthAppShellBrandsBrandIdEditRoute,
    AuthAppShellBrandsBrandIdKnowledgeRoute:
      AuthAppShellBrandsBrandIdKnowledgeRoute,
    AuthAppShellBrandsBrandIdOverviewRoute:
      AuthAppShellBrandsBrandIdOverviewRoute,
    AuthAppShellBrandsBrandIdRequestsRoute:
      AuthAppShellBrandsBrandIdRequestsRoute,
    AuthAppShellBrandsBrandIdVisualdirectionRoute:
      AuthAppShellBrandsBrandIdVisualdirectionRoute,
    AuthAppShellBrandsBrandIdIndexRoute: AuthAppShellBrandsBrandIdIndexRoute,
  }

const AuthAppShellBrandsBrandIdRouteWithChildren =
  AuthAppShellBrandsBrandIdRoute._addFileChildren(
    AuthAppShellBrandsBrandIdRouteChildren,
  )

interface AuthAppShellProjectsProjectIdRouteChildren {
  AuthAppShellProjectsProjectIdBrandsRoute: typeof AuthAppShellProjectsProjectIdBrandsRoute
  AuthAppShellProjectsProjectIdEditRoute: typeof AuthAppShellProjectsProjectIdEditRoute
  AuthAppShellProjectsProjectIdInternalNotesRoute: typeof AuthAppShellProjectsProjectIdInternalNotesRoute
  AuthAppShellProjectsProjectIdUsersRoute: typeof AuthAppShellProjectsProjectIdUsersRoute
  AuthAppShellProjectsProjectIdIndexRoute: typeof AuthAppShellProjectsProjectIdIndexRoute
}

const AuthAppShellProjectsProjectIdRouteChildren: AuthAppShellProjectsProjectIdRouteChildren =
  {
    AuthAppShellProjectsProjectIdBrandsRoute:
      AuthAppShellProjectsProjectIdBrandsRoute,
    AuthAppShellProjectsProjectIdEditRoute:
      AuthAppShellProjectsProjectIdEditRoute,
    AuthAppShellProjectsProjectIdInternalNotesRoute:
      AuthAppShellProjectsProjectIdInternalNotesRoute,
    AuthAppShellProjectsProjectIdUsersRoute:
      AuthAppShellProjectsProjectIdUsersRoute,
    AuthAppShellProjectsProjectIdIndexRoute:
      AuthAppShellProjectsProjectIdIndexRoute,
  }

const AuthAppShellProjectsProjectIdRouteWithChildren =
  AuthAppShellProjectsProjectIdRoute._addFileChildren(
    AuthAppShellProjectsProjectIdRouteChildren,
  )

interface AuthAppShellRouteChildren {
  AuthAppShellMakeASuggestionRoute: typeof AuthAppShellMakeASuggestionRoute
  AuthAppShellAdminConfidenceCheckerRoute: typeof AuthAppShellAdminConfidenceCheckerRoute
  AuthAppShellBillingProjectIdRoute: typeof AuthAppShellBillingProjectIdRouteWithChildren
  AuthAppShellBrandsBrandIdRoute: typeof AuthAppShellBrandsBrandIdRouteWithChildren
  AuthAppShellBrandsCreateRoute: typeof AuthAppShellBrandsCreateRoute
  AuthAppShellMyFilesTemplateRoute: typeof AuthAppShellMyFilesTemplateRoute
  AuthAppShellNotificationsSettingsRoute: typeof AuthAppShellNotificationsSettingsRoute
  AuthAppShellPaywallExpiredSubscriptionRoute: typeof AuthAppShellPaywallExpiredSubscriptionRoute
  AuthAppShellPaywallNoCreditsRoute: typeof AuthAppShellPaywallNoCreditsRoute
  AuthAppShellProfileDesignerPreferenceRoute: typeof AuthAppShellProfileDesignerPreferenceRoute
  AuthAppShellProjectAssociatedRequestsProjectIdRoute: typeof AuthAppShellProjectAssociatedRequestsProjectIdRoute
  AuthAppShellProjectsProjectIdRoute: typeof AuthAppShellProjectsProjectIdRouteWithChildren
  AuthAppShellRequestsCreateRoute: typeof AuthAppShellRequestsCreateRoute
  AuthAppShellRequestsMbcRoute: typeof AuthAppShellRequestsMbcRoute
  AuthAppShellRequestsMbcReviewRoute: typeof AuthAppShellRequestsMbcReviewRoute
  AuthAppShellRequestsPickTypeRoute: typeof AuthAppShellRequestsPickTypeRoute
  AuthAppShellRequestsTemplateRoute: typeof AuthAppShellRequestsTemplateRoute
  AuthAppShellTeamsCreateRoute: typeof AuthAppShellTeamsCreateRoute
  AuthAppShellUserProfileRoute: typeof AuthAppShellUserProfileRoute
  AuthAppShellUsersCreateRoute: typeof AuthAppShellUsersCreateRoute
  AuthAppShellWhitelabelCreateRoute: typeof AuthAppShellWhitelabelCreateRoute
  AuthAppShellWhitelabelDashboardRoute: typeof AuthAppShellWhitelabelDashboardRoute
  AuthAppShellBillingIndexRoute: typeof AuthAppShellBillingIndexRoute
  AuthAppShellBrandsIndexRoute: typeof AuthAppShellBrandsIndexRoute
  AuthAppShellDashboardIndexRoute: typeof AuthAppShellDashboardIndexRoute
  AuthAppShellIssuesReportsIndexRoute: typeof AuthAppShellIssuesReportsIndexRoute
  AuthAppShellMyFilesIndexRoute: typeof AuthAppShellMyFilesIndexRoute
  AuthAppShellNotificationsIndexRoute: typeof AuthAppShellNotificationsIndexRoute
  AuthAppShellProjectsIndexRoute: typeof AuthAppShellProjectsIndexRoute
  AuthAppShellPublishIndexRoute: typeof AuthAppShellPublishIndexRoute
  AuthAppShellRequestsIndexRoute: typeof AuthAppShellRequestsIndexRoute
  AuthAppShellTeamsIndexRoute: typeof AuthAppShellTeamsIndexRoute
  AuthAppShellTrashIndexRoute: typeof AuthAppShellTrashIndexRoute
  AuthAppShellUsersIndexRoute: typeof AuthAppShellUsersIndexRoute
  AuthAppShellWhitelabelIndexRoute: typeof AuthAppShellWhitelabelIndexRoute
  AuthAppShellAdminDesignTypesDesignTypeIdRoute: typeof AuthAppShellAdminDesignTypesDesignTypeIdRoute
  AuthAppShellAdminSubcategoriesSubCategoryIdRoute: typeof AuthAppShellAdminSubcategoriesSubCategoryIdRoute
  AuthAppShellPublishPostsPostIdRoute: typeof AuthAppShellPublishPostsPostIdRoute
  AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute: typeof AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute
  AuthAppShellRequestsRequestIdEditRoute: typeof AuthAppShellRequestsRequestIdEditRoute
  AuthAppShellTeamsIdEditRoute: typeof AuthAppShellTeamsIdEditRoute
  AuthAppShellUsersUserIdEditRoute: typeof AuthAppShellUsersUserIdEditRoute
  AuthAppShellWhitelabelConfigIdEditRoute: typeof AuthAppShellWhitelabelConfigIdEditRoute
  AuthAppShellAdminDesignTypesIndexRoute: typeof AuthAppShellAdminDesignTypesIndexRoute
  AuthAppShellAdminMbcIndexRoute: typeof AuthAppShellAdminMbcIndexRoute
  AuthAppShellAdminSubcategoriesIndexRoute: typeof AuthAppShellAdminSubcategoriesIndexRoute
  AuthAppShellAdminMbcChecksCheckIdRoute: typeof AuthAppShellAdminMbcChecksCheckIdRoute
  AuthAppShellAdminMbcChecksNewRoute: typeof AuthAppShellAdminMbcChecksNewRoute
  AuthAppShellAdminMbcGuidelinesGuidelineIdRoute: typeof AuthAppShellAdminMbcGuidelinesGuidelineIdRoute
  AuthAppShellAdminMbcGuidelinesNewRoute: typeof AuthAppShellAdminMbcGuidelinesNewRoute
}

const AuthAppShellRouteChildren: AuthAppShellRouteChildren = {
  AuthAppShellMakeASuggestionRoute: AuthAppShellMakeASuggestionRoute,
  AuthAppShellAdminConfidenceCheckerRoute:
    AuthAppShellAdminConfidenceCheckerRoute,
  AuthAppShellBillingProjectIdRoute:
    AuthAppShellBillingProjectIdRouteWithChildren,
  AuthAppShellBrandsBrandIdRoute: AuthAppShellBrandsBrandIdRouteWithChildren,
  AuthAppShellBrandsCreateRoute: AuthAppShellBrandsCreateRoute,
  AuthAppShellMyFilesTemplateRoute: AuthAppShellMyFilesTemplateRoute,
  AuthAppShellNotificationsSettingsRoute:
    AuthAppShellNotificationsSettingsRoute,
  AuthAppShellPaywallExpiredSubscriptionRoute:
    AuthAppShellPaywallExpiredSubscriptionRoute,
  AuthAppShellPaywallNoCreditsRoute: AuthAppShellPaywallNoCreditsRoute,
  AuthAppShellProfileDesignerPreferenceRoute:
    AuthAppShellProfileDesignerPreferenceRoute,
  AuthAppShellProjectAssociatedRequestsProjectIdRoute:
    AuthAppShellProjectAssociatedRequestsProjectIdRoute,
  AuthAppShellProjectsProjectIdRoute:
    AuthAppShellProjectsProjectIdRouteWithChildren,
  AuthAppShellRequestsCreateRoute: AuthAppShellRequestsCreateRoute,
  AuthAppShellRequestsMbcRoute: AuthAppShellRequestsMbcRoute,
  AuthAppShellRequestsMbcReviewRoute: AuthAppShellRequestsMbcReviewRoute,
  AuthAppShellRequestsPickTypeRoute: AuthAppShellRequestsPickTypeRoute,
  AuthAppShellRequestsTemplateRoute: AuthAppShellRequestsTemplateRoute,
  AuthAppShellTeamsCreateRoute: AuthAppShellTeamsCreateRoute,
  AuthAppShellUserProfileRoute: AuthAppShellUserProfileRoute,
  AuthAppShellUsersCreateRoute: AuthAppShellUsersCreateRoute,
  AuthAppShellWhitelabelCreateRoute: AuthAppShellWhitelabelCreateRoute,
  AuthAppShellWhitelabelDashboardRoute: AuthAppShellWhitelabelDashboardRoute,
  AuthAppShellBillingIndexRoute: AuthAppShellBillingIndexRoute,
  AuthAppShellBrandsIndexRoute: AuthAppShellBrandsIndexRoute,
  AuthAppShellDashboardIndexRoute: AuthAppShellDashboardIndexRoute,
  AuthAppShellIssuesReportsIndexRoute: AuthAppShellIssuesReportsIndexRoute,
  AuthAppShellMyFilesIndexRoute: AuthAppShellMyFilesIndexRoute,
  AuthAppShellNotificationsIndexRoute: AuthAppShellNotificationsIndexRoute,
  AuthAppShellProjectsIndexRoute: AuthAppShellProjectsIndexRoute,
  AuthAppShellPublishIndexRoute: AuthAppShellPublishIndexRoute,
  AuthAppShellRequestsIndexRoute: AuthAppShellRequestsIndexRoute,
  AuthAppShellTeamsIndexRoute: AuthAppShellTeamsIndexRoute,
  AuthAppShellTrashIndexRoute: AuthAppShellTrashIndexRoute,
  AuthAppShellUsersIndexRoute: AuthAppShellUsersIndexRoute,
  AuthAppShellWhitelabelIndexRoute: AuthAppShellWhitelabelIndexRoute,
  AuthAppShellAdminDesignTypesDesignTypeIdRoute:
    AuthAppShellAdminDesignTypesDesignTypeIdRoute,
  AuthAppShellAdminSubcategoriesSubCategoryIdRoute:
    AuthAppShellAdminSubcategoriesSubCategoryIdRoute,
  AuthAppShellPublishPostsPostIdRoute: AuthAppShellPublishPostsPostIdRoute,
  AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute:
    AuthAppShellRequestsRequestIdConfidenceCheckerSummaryRoute,
  AuthAppShellRequestsRequestIdEditRoute:
    AuthAppShellRequestsRequestIdEditRoute,
  AuthAppShellTeamsIdEditRoute: AuthAppShellTeamsIdEditRoute,
  AuthAppShellUsersUserIdEditRoute: AuthAppShellUsersUserIdEditRoute,
  AuthAppShellWhitelabelConfigIdEditRoute:
    AuthAppShellWhitelabelConfigIdEditRoute,
  AuthAppShellAdminDesignTypesIndexRoute:
    AuthAppShellAdminDesignTypesIndexRoute,
  AuthAppShellAdminMbcIndexRoute: AuthAppShellAdminMbcIndexRoute,
  AuthAppShellAdminSubcategoriesIndexRoute:
    AuthAppShellAdminSubcategoriesIndexRoute,
  AuthAppShellAdminMbcChecksCheckIdRoute:
    AuthAppShellAdminMbcChecksCheckIdRoute,
  AuthAppShellAdminMbcChecksNewRoute: AuthAppShellAdminMbcChecksNewRoute,
  AuthAppShellAdminMbcGuidelinesGuidelineIdRoute:
    AuthAppShellAdminMbcGuidelinesGuidelineIdRoute,
  AuthAppShellAdminMbcGuidelinesNewRoute:
    AuthAppShellAdminMbcGuidelinesNewRoute,
}

const AuthAppShellRouteWithChildren = AuthAppShellRoute._addFileChildren(
  AuthAppShellRouteChildren,
)

interface AuthRouteChildren {
  AuthAppShellRoute: typeof AuthAppShellRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppShellRoute: AuthAppShellRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  CreatePasswordRoute: CreatePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  KickstarterRoute: KickstarterRoute,
  KickstarterCallRoute: KickstarterCallRoute,
  LoginRoute: LoginRoute,
  OnboardingCallRoute: OnboardingCallRoute,
  PricingRoute: PricingRoute,
  SubscriptionRoute: SubscriptionRoute,
  SubscriptionSuccessRoute: SubscriptionSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
